document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".continuous-gallery");

  if (!sections.length) return;

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    const transitionSpeed =
      parseInt(section.dataset.transitionSpeed, 10) || 9000;
    const spaceBetween = parseInt(section.dataset.spaceBetween, 10) || 0;
    const showPagination = section.dataset.showPagination === "true";
    const grabCursor = section.dataset.grabCursor === "true";

    const swiperEl = section.querySelector(".continuous-gallery__swiper");
    if (!swiperEl || typeof Swiper === "undefined") return;

    const originalSlides = swiperEl.querySelectorAll(".swiper-slide");
    const totalSlides = originalSlides.length;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween,
      loop: true,
      speed: transitionSpeed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      grabCursor,
      allowTouchMove: true,
      on: {
        init: function () {
          if (showPagination) {
            initializeProgressBars(this);
          }
        },
      },
    });

    function initializeProgressBars(swiperInstance) {
      const paginationEl = section.querySelector(
        ".continuous-gallery__pagination"
      );
      if (!paginationEl || totalSlides === 0) return;

      const progressBars = [];
      paginationEl.innerHTML = "";

      for (let i = 0; i < totalSlides; i++) {
        const progressBar = document.createElement("div");
        progressBar.classList.add("progress-bar");
        paginationEl.appendChild(progressBar);
        progressBars.push(progressBar);
      }

      const totalGap = 12 * (totalSlides - 1);
      const totalPadding = 16;
      const availableWidth = window.innerWidth - totalGap - totalPadding;
      const barWidth = availableWidth / totalSlides;

      progressBars.forEach((bar) => {
        bar.style.flex = `0 0 ${barWidth}px`;
        bar.style.minWidth = `${barWidth}px`;
      });

      function updateProgressAnimation() {
        if (!sectionId) return;
        const styleId = "continuous-progress-animation-" + sectionId;
        let styleEl = document.getElementById(styleId);

        if (!styleEl) {
          styleEl = document.createElement("style");
          styleEl.id = styleId;
          document.head.appendChild(styleEl);
        }

        styleEl.textContent = `
          #section-${sectionId} .progress-bar.active::before {
            animation: fillProgress-${sectionId} linear forwards ${transitionSpeed}ms;
          }

          @keyframes fillProgress-${sectionId} {
            0% {
              width: 0;
            }
            100% {
              width: 100%;
            }
          }
        `;
      }

      updateProgressAnimation();

      function updateProgressBars(index) {
        const realIndex = index >= 0 && index < totalSlides ? index : 0;

        progressBars.forEach((bar, i) => {
          bar.classList.remove("active");

          if (i < realIndex) {
            bar.classList.add("completed");
          } else {
            bar.classList.remove("completed");
          }
        });

        const currentBar = progressBars[realIndex];
        if (currentBar) {
          currentBar.classList.remove("completed");
          void currentBar.offsetWidth;
          currentBar.classList.add("active");
        }
      }

      updateProgressBars(swiperInstance.realIndex);

      swiperInstance.on("slideChange", function () {
        updateProgressBars(this.realIndex);
      });

      const resizeHandler = function () {
        const newAvailableWidth = window.innerWidth - totalGap - totalPadding;
        const newBarWidth = newAvailableWidth / totalSlides;

        progressBars.forEach((bar) => {
          bar.style.flex = `0 0 ${newBarWidth}px`;
          bar.style.minWidth = `${newBarWidth}px`;
        });
      };

      window.addEventListener("resize", resizeHandler);
    }

    swiper.on("touchEnd", function () {
      if (swiper.autoplay) {
        swiper.autoplay.start();
      }
    });
  });
});
